import * as React from 'react';
import styles from './tooltip.module.css';
import call from '../images/call.png';
import msg from '../images/msg.png';

export const TooltipComponent: React.FC<any> = props => {
	const { name, company, phoneNumber, emailAddress } = props.advisorDetails;
	return (
		<div className={`${styles.tooltiptext}`}>
			<div className={`${styles.tooltipBody}`}>
				<span className={`${styles.closeTooltip}`} onClick={props.click}>
					X
				</span>
				<div className={`${styles.tooltipImg}`}>
				{(props.advisorImage && props.advisorImage !== '') && <img src={props.advisorImage} alt="advisor photo" className={`${styles.userImg}`} />}
				</div>
				<div className={`${styles.user}`}>
					<p className={`${styles.userName}`}>{name}</p>
					<p className={`text-left ${styles.userDeg}`}>{company}</p>
					<div className={`${styles.userPhone}`}>
						<img src={call} className={`${styles.callImg}`} alt="phone img" />
						<p>{phoneNumber}</p>
					</div>
					<div className={`flex ${styles.userEmail}`}>
						<img src={msg} className={`${styles.msgImg}`} alt="phone img" />
						<p>{emailAddress}</p>
					</div>
				</div>
			</div>
		</div>
	);
};
